export default "__VITE_ASSET__COh72aDb__"